import { render, staticRenderFns } from "./TemplateMultiRead.vue?vue&type=template&id=7f60a7a0&scoped=true&"
import script from "./TemplateMultiRead.vue?vue&type=script&lang=js&"
export * from "./TemplateMultiRead.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMultiRead.vue?vue&type=style&index=0&id=7f60a7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f60a7a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
